import React from 'react';
import Tooltip from '../ui/Tooltip';
import { listBadgeTone } from '../../extensions/bundled/task-manager/boardProgress';
import { GroupTitle, GroupHeaderMenu } from './GroupHeader';
import ColumnProgress from './ColumnProgress';
import './ColumnHeader.css';

/** Kanban column header card (Boards Redesign card 3.1 + 3.2): numbered tint
 *  badge, list name (click to rename, as before), done/total pill, the ⋯ menu,
 *  and the progress bar underneath. The whole card is the column's drag
 *  handle — `dragHandleProps` are dnd-kit's attributes + listeners. */
export default function ColumnHeader({ group, index, progress, showProgress = true, editing, setEditing, onRename, onDelete, dragHandleProps }) {
  const { done = 0, total = 0 } = progress || {};
  const tone = listBadgeTone(index);
  return (
    <div className="task-board-column-header task-board-column-header--card" {...dragHandleProps}>
      <div className="task-board-column-header-row">
        <span className={`task-board-col-badge task-board-col-badge--${tone}`} aria-hidden="true">
          {index + 1}
        </span>
        <GroupTitle group={group} editing={editing} setEditing={setEditing} onRename={onRename} />
        <Tooltip content={`${done} of ${total} done`} side="bottom">
          <span className="task-board-col-pill" aria-label={`${done} of ${total} done`}>
            {done}/{total}
          </span>
        </Tooltip>
        <GroupHeaderMenu onRename={() => setEditing(true)} onDelete={onDelete} />
      </div>
      {showProgress && <ColumnProgress progress={progress} />}
    </div>
  );
}
